<template>
  <div class="forget-password">
    <div>
      <el-steps :active="step" finish-status="success">
        <el-step title="身份验证"></el-step>
        <el-step title="更改密码"></el-step>
        <el-step title="完成"></el-step>
      </el-steps>
    </div>
    <div class="form">
      <div class="form">
        <el-form :rules="rules" ref="form" label-position="right" label-width="420px" :model="form">
          <el-form-item v-show="step === 0" label="手机号" prop="telphone">
            <el-input
              :maxlength="11"
              v-model="form.telphone"
              placeholder="请输入手机号"
              style="width: 270px;"
            ></el-input>
            <button
              type="button"
              style="width: 140px;height: 39px;"
              class="common-btn"
              :disabled="state.smsSendBtn"
              @click.stop.prevent="getCheckCode"
              v-text="!state.smsSendBtn && '获取验证码' || (state.time+' s')">获取验证码</button>
          </el-form-item>
          <el-form-item v-show="step === 0" label="验证码">
            <el-input v-model="form.checkCode" placeholder="请输入手机短信验证码"></el-input>
          </el-form-item>
          <el-form-item v-if="step === 1" label="设置新密码" prop="password">
            <el-input type="password" v-model="form.password" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item v-if="step === 1" label="确认密码" prop="repwd">
            <el-input type="password" v-model="form.repwd" placeholder="请再次输入密码"></el-input>
          </el-form-item>
          <el-form-item v-if="step <= 1">
            <button
              type="button"
              style="width: 420px;height: 39px;font-size:18px;"
              class="common-btn"
              @click="submitForm('form')"
            >下一步</button>
          </el-form-item>
          <p style="font-size: 24px;text-align: center">修改密码成功！</p>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getCheckCode, updatePassword } from "@/js/api";

export default {
  name: "UserHome",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.repwd !== "") {
          this.$refs.form.validateField("repwd");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var checkPassword = (rule, value, callback) => {
      //密码强度正则，最少6位，包括至少1个大写字母，1个小写字母，1个数字，1个特殊字符
      // var reg = new RegExp(
      //   /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/
      // );
      var reg = new RegExp(
        /^.*(?=.{6,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/
      );
      if (!reg.test(value))
        callback(new Error("请输入带有大小写英文和数字的密码"));
      else callback();
    };
    return {
      step: 0,
      form: {
        userType: 0,
        username: "",
        password: "",
        repwd: ""
      },
      state: {
        time: 300,
        smsSendBtn: false,
      },
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
          { validator: checkPassword, trigger: "change" }
        ],
        repwd: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" }
        ],
        telphone: [
          { required: true, message: "请输入11位手机号", trigger: "change" },
          { min: 11, max: 11, message: "请输入11位手机号", trigger: "blur" }
        ],
        checkCode: [
          { required: true, message: "请输入手机短信验证码", trigger: "change" }
        ]
      }
    };
  },
  methods: {
    nextStep() {
      this.step++;
    },
    getCheckCode() {
      if (this.form.telphone) {
        getCheckCode({
          telphone: this.form.telphone,
          type: 'TELPHONE_PASSWORD'
        }).then(res => {
          if (res.code == 0) {
            this.state.smsSendBtn = true;
            let interval = window.setInterval(() => {
              if (this.state.time-- <= 0) {
                this.state.time = 300;
                this.state.smsSendBtn = false;
                window.clearInterval(interval);
              }
            }, 1000);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const sdata = {
            // password: "Aa123456#",
            checkCode: this.form.checkCode,
            telphone: this.form.telphone
          };
          if (this.form.password) {
            sdata.password = this.form.password;
          }
          updatePassword(sdata).then(res => {
            if (res.code == 0) {
              if (this.step === 0) {
                this.$message.success("验证通过，请输入新密码！");
                this.step++;
              } else if (this.step === 1) {
                this.$message.success(res.message);
                this.step++;
              }
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goOrder() {
      this.$router.push("/user/order");
    }
  },
  beforeCreate() {
    if (this.$store.state.user.username) {
      this.$router.push("/");
    }
  }
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: orange;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
<style scoped>
.form .input >>> .el-input__inner {
  line-height: 48px;
  height: 48px;
  border-radius: 24px;
}
.form >>> .el-input {
  width: 420px;
}
.form >>> .el-select {
  width: 420px;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less'>
.flex {
  display: flex;
  align-items: center;
}
.head {
  position: relative;
  margin: 44px 0 20px;
  text-align: center;
  font-size: 20px;
  p:last-child {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    line-height: 1;
    height: 20px;
  }
}
.title {
  font-size: 24px;
  font-weight: bold;
}
.forget-password {
  padding: 40px;
  width: 1060px;
  margin: auto;
  .form {
    margin-top: 40px;
    width: 1060px;
  }
}
</style>
